import React, { FC } from 'react';
import { Text } from '../Text/Text';
import styled from 'styled-components';
import { COLORS, device } from '../../constants';

interface TechnologyElementProps {
  src: string;
  title: string;
}

const TechnologyElement: FC<TechnologyElementProps> = ({ src, title }) => {
  return (
    <TechnologyElementWrapper>
      <TechIMG draggable={false} src={src} />
      <Text size={16} weight={600} text={title} />
    </TechnologyElementWrapper>
  );
};

const TechnologyElementWrapper = styled.div`
  display: flex;
  padding: 10px;
  gap: 10px;
  flex-shrink: 0;
  height: 44px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.ACTIVE_ITEM};
  > h4 {
    white-space: nowrap;
  }
  @media screen and ${device.md} {
    height: 30px;
    gap: 5px;
    > h4 {
      font-size: 13px;
    }
  }
  @media screen and ${device.sm} {
    height: 30px;
    padding: 5px;
    gap: 5px;
    > h4 {
      font-size: 10px;
    }
    min-width: 0;
  }
`;
const TechIMG = styled.img`
  width: 18px;
  height: 18px;
  @media screen and ${device.sm} {
    width: 12px;
    height: 12px;
  }
`;

export { TechnologyElement };
